import { FormControl, TextField } from '@mui/material';
//constants
import { customValueTypes, field, formThemes } from '../types';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getFormattedAmountInputDisplayValue, getRawAmountInputValue } from '../helpers';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
	formTheme?: formThemes;
	suffix?: string;
};

export default function InputText(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation, formTheme } = props;
	const { name, value, helperText, regex } = cField.props;
	const variant = formTheme === formThemes.hiddenInputs ? 'outlined' : 'filled';
	const label = formTheme === formThemes.hiddenInputs ? '' : cField.props.label;
	const isAmountField = cField.customValueType === customValueTypes.integer;

	const displayValue = isAmountField
		? getFormattedAmountInputDisplayValue(value)
		: ['null', 'undefined'].includes(typeof value)
		? ''
		: cField.props.disabled
		? value?.toLocaleString()
		: value;

	const handleInputChange = (event) => {
		const newValue = event.target.value;
		const nextValue = isAmountField ? getRawAmountInputValue(newValue) : newValue;
		const nextEvent = isAmountField
			? {
					...event,
					target: {
						...event.target,
						value: nextValue,
					},
			  }
			: event;

		if (regex) {
			regex.test(nextValue) && handleChange(nextEvent);
		} else {
			handleChange(nextEvent);
		}
	};

	const inputSuffix = cField.suffix ? { InputProps: { endAdornment: cField.suffix } } : {};
	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<TextField
					error={!valid}
					{...cField.props}
					label={label}
					helperText={valid ? helperText : t(getErrorText(initialValidation, name)) || helperText}
					value={displayValue}
					onChange={handleInputChange}
					variant={variant}
					autoComplete="off"
					{...inputSuffix}
				/>
			</FormControl>
		</CustomTextField>
	);
}
